const BASE_UF = "uf/api/v1";
const BASE_IX = "ix/api/v1";
const BASE_RO = "ro/api/v1";
const BASE_WM = "wm/api/v1";
const BASE_MASTER_DATA = "masterdata/api/v1";
const BASE_USER_PROFILE = "userprofile/api/v1";
const SSO_BASE = import.meta.env.VITE_TOKEN_SFDCURL;

export const SSO_URLs = {
  ssoToken: `${SSO_BASE}oauth2/token`,
  ssoAuthorize: `${SSO_BASE}oauth2/authorize`,
  signOutUrl: `${SSO_BASE}auth/idp/oidc/logout`,
};

export const EXTERNAL_URLS = {
  dupontUrl: "https://www.dupont.com/",
  waveProURL: "https://wavepro.dupont.com",
  privacyUrl: "https://www.dupont.com/privacy.html",
  a11yUrl: "https://www.dupont.com/accessibility.html",
  contactDupontUrl: "https://www.dupont.com/water/contact-us.html",
  engagementURL: "https://www.dupont.com/dupont/submitForm?orgId=WS",
  resourceCenterUrl: "https://www.dupont.com/resource-center.html?BU=water",
  termsConditions: "https://www.dupont.com/legal-notices-and-terms-of-use.html",
  ufConfigurationHelp: "https://watersolutions.showpad.com/share/mQ7eHe3T8KitIs6g9dzAp",
  carouselLink: "https://www.dupont.com/water/resources/wave-pro-design-software.html",
  ultrafiltrationURL: "https://www.dupont.com/water/technologies/ultrafiltration-uf.html",
  ionExchangeURL: "https://www.dupont.com/water/technologies/ion-exchange-ix.html",
  reverseOsmosisURL: "https://www.dupont.com/water/technologies/reverse-osmosis-ro.html",
  nanoFiltrationURL: "https://www.dupont.com/water/technologies/nanofiltration-nf.html",
  youtubeURL: "https://www.youtube.com/channel/UCWVgaECFNjMWDczgCTI4pFw",
  instagramURl:
    "https://www.instagram.com/accounts/login/?next=https%3A%2f%2fwww.instagram.com%2fdupontwatersolutions%2f&is_from_rle",
  linkedinURL: "https://www.linkedin.com/showcase/dupont-water-solutions",
  digitalTermsConditions: "https://water-protection.dupont.com/digital-program-terms-and-conditions-of-use.html",
  myProfile: "https://www.dupont.com/signin/my-profile.html",
  detailedAccessGuide:
    "https://www.dupont.com/content/dam/water/amer/us/en/water/public/documents/en/DWS-WAVE-PRO-Request-Access-PPT-45-D04879-en.pdf",
  videoTutorials:
    "https://www.dupont.com/water/resources/wave-pro-design-software.html?src=ws_global_email-signature_wavepro_email_email_03.28.2025",
  additionalGuidanceContact:
    "https://www.dupont.com/water/contact-us.html?dfp=water-webinar-ultrafiltration-operations-advisor",
};

export const getResourceURLs = {
  en: "https://www.dupont.com/resource-center.html?BU=water",
  es: "https://www.dupont.es/resource-center.html?BU=water",
  zh: "https://www.dupont.cn/resource-center.html?BU=water-solutions",
};

export const getContactUsURLs = {
  en: "https://www.dupont.com/water/contact-us.html",
  es: "https://www.dupont.es/water/contact-us.html",
  zh: "https://www.dupont.cn/water/contact-us.html",
};

export const FOOTER_URL = {
  en: {
    dupontUrl: "https://www.dupont.com/",
    privacyUrl: "https://www.dupont.com/privacy.html",
    termsConditions: "https://www.dupont.com/legal-notices-and-terms-of-use.html",
    a11yUrl: "https://www.dupont.com/accessibility.html",
  },
  es: {
    dupontUrl: "https://www.dupont.es/",
    privacyUrl: "https://www.dupont.es/privacy.html",
    termsConditions: "https://www.dupont.es/legal-notices-and-terms-of-use.html",
    a11yUrl: "https://www.dupont.es/accessibility.html",
  },
  zh: {
    dupontUrl: "https://www.dupont.cn/",
    privacyUrl: "https://www.dupont.cn/privacy.html",
    termsConditions: "https://www.dupont.cn/legal-notices-and-terms-of-use.html",
    a11yUrl: "https://www.dupont.cn/accessibility.html",
  },
};

export const WAVE_PRO_SUPPORT_MAIL = "wavepro.support@dupont.com";

const MASTER_DATA = {
  pumps: `${BASE_MASTER_DATA}/Pumps`,
  cases: `${BASE_MASTER_DATA}/Cases`,
  state: `${BASE_MASTER_DATA}/State`,
  folder: `${BASE_MASTER_DATA}/Folder`,
  project: `${BASE_MASTER_DATA}/Projects`,
  caseMgmt: `${BASE_MASTER_DATA}/CaseMgmt`,
  waterCatalog: `${BASE_MASTER_DATA}/WaterType`,
  feedWater: `${BASE_MASTER_DATA}/FeedWater`,
  feedSetup: `${BASE_MASTER_DATA}/FeedSetup`,
  folderList: `${BASE_MASTER_DATA}/FolderList`,
  countriesList: `${BASE_MASTER_DATA}/Country`,
  projectAll: `${BASE_MASTER_DATA}/ProjectAll`,
  allProjects: `${BASE_MASTER_DATA}/ProjectAll`,
  projectInfo: `${BASE_MASTER_DATA}/ProjectInfo`,
  sendProject: `${BASE_MASTER_DATA}/SendProject`,
  openProjects: `${BASE_MASTER_DATA}/OpenProject`,
  projectState: `${BASE_MASTER_DATA}/ProjectState`,
  systemDesign: `${BASE_MASTER_DATA}/SystemDesign`,
  projectStatus: `${BASE_MASTER_DATA}/EntityCheck`,
  deleteFolder: `${BASE_MASTER_DATA}/DeleteFolder`,
  shareProject: `${BASE_MASTER_DATA}/ShareProject`,
  restoreFolder: `${BASE_MASTER_DATA}/RestoreFolder`,
  subTechnology: `${BASE_MASTER_DATA}/SubTechnology`,
  notifications: `${BASE_MASTER_DATA}/Notifications`,
  marketSegment: `${BASE_MASTER_DATA}/MarketSegment`,
  renameProject: `${BASE_MASTER_DATA}/RenameProject`,
  folderProject: `${BASE_MASTER_DATA}/FolderProject`,
  projectNumber: `${BASE_MASTER_DATA}/ProjectNumber`,
  unitOfMeasure: `${BASE_MASTER_DATA}/UnitOfMeassure`,
  recentProjects: `${BASE_MASTER_DATA}/ProjectRecent`,
  projectDeleted: `${BASE_MASTER_DATA}/ProjectDeleted`,
  restoreProject: `${BASE_MASTER_DATA}/RestoreProject`,
  allUsersForSend: `${BASE_MASTER_DATA}/AllUsersForSend`,
  favoriteProject: `${BASE_MASTER_DATA}/FavoriteProject`,
  defaultCurrency: `${BASE_MASTER_DATA}/DefaultCurrency`,
  projectFavorite: `${BASE_MASTER_DATA}/ProjectFavorite`,
  duplicateProject: `${BASE_MASTER_DATA}/DuplicateProject`,
  defaultFeedSetup: `${BASE_MASTER_DATA}/DefaultFeedSetup`,
  unitConversionData: `${BASE_MASTER_DATA}/UnitConversion`,
  chemicalCategory: `${BASE_MASTER_DATA}/ChemicalCategory`,
  projAlredaySentTo: `${BASE_MASTER_DATA}/ProjAlredaySentTo`,
  categoryTreatment: `${BASE_MASTER_DATA}/CategoryTreatment`, // Not to be used in the Multi Tech refactor, to be removed
  defaultTechnology: `${BASE_MASTER_DATA}/DefaultTechnology`,
  applicationVersion: `${BASE_MASTER_DATA}/ApplicationVersion`,
  chemicalAdjustment: `${BASE_MASTER_DATA}/ChemicalAdjustment`,
  waterQualityAdjustment: `${BASE_MASTER_DATA}/WaterQualityAdjustment`,
  shareProjectLocked: `${BASE_MASTER_DATA}/ShareProject/Locked`,
  shareProjectHistory: `${BASE_MASTER_DATA}/ShareProject/History`,
  permanentDeleteFolder: `${BASE_MASTER_DATA}/PermanentDeleteFolder`,
  projectFolderMapping: `${BASE_MASTER_DATA}/ProjectFolderIDMapping`,
  calculateFeedWaterData: `${BASE_MASTER_DATA}/CalculateFeedWaterData`,
  shareProjectLockUnlock: `${BASE_MASTER_DATA}/ShareProject/LockUnlock`,
  shareProjectCollaborators: `${BASE_MASTER_DATA}/ShareProject/Collaborators`,
  shareProjectRequestUnlock: `${BASE_MASTER_DATA}/ShareProject/RequestUnlock`,
  calculateChemicalAdjustment: `${BASE_MASTER_DATA}/CalculateChemicalAdjustment`,
  shareProjectTransferOwnership: `${BASE_MASTER_DATA}/ShareProject/OwnershipTransfer`,
};

const MLD_URLS = {
  multiTechReport: `${BASE_MASTER_DATA}/MultitechReport`,
  mldReportRequest: `${BASE_MASTER_DATA}/MLDReport`,
  mldReportStatus: `${BASE_MASTER_DATA}/MLDReport`,
  mldReportJobs: `${BASE_MASTER_DATA}/MLDReportJobs`, //not implemented yet
  mldReportCancel: `${BASE_MASTER_DATA}/MLDCancelJob`, //not implemented yet
};

const USER_PROFILE = {
  userData: `${BASE_USER_PROFILE}/UserData`,
  ixdUsers: `${BASE_USER_PROFILE}/IXDUsers`,
  importProject: `${BASE_USER_PROFILE}/Import`,
  exportProject: `${BASE_USER_PROFILE}/Export`,
  firstLogin: `${BASE_USER_PROFILE}/FirstLogin`,
  languageList: `${BASE_USER_PROFILE}/Language`,
  waterLibrary: `${BASE_USER_PROFILE}/WaterLibrary`,
  digitalTerms: `${BASE_USER_PROFILE}/DigitalTerms`,
  exampleProject: `${BASE_USER_PROFILE}/ExampleProject`,
  chemicalLibrary: `${BASE_USER_PROFILE}/ChemicalLibrary`,
  userInformation: `${BASE_USER_PROFILE}/UserInformation`,
  languageTranslation: `${BASE_USER_PROFILE}/Language/Translations`,
  projectCosts: `${BASE_USER_PROFILE}/ChemicalLibrary/ProjectCosts`,
  chemicalLibraryCategory: `${BASE_USER_PROFILE}/ChemicalLibrary/Categories`,
  chemicalLibraryChemicalUsage: `${BASE_USER_PROFILE}/ChemicalLibrary/ChemicalUsage`,
  defaultChemicalPriceAndUtilityCost: `${BASE_USER_PROFILE}/ChemicalLibrary/ProjectCosts/MakeDefault`,
  userRoleLicense: `${BASE_USER_PROFILE}/UserRoleLicense`,
  licensePermission: `${BASE_USER_PROFILE}/LicensePermission`,
  userLicenseValidate: `${BASE_USER_PROFILE}/UserLicenseValidate`,
  userAssignLicense: `${BASE_USER_PROFILE}/UserLicense`,
  userLicenseTerminate: `${BASE_USER_PROFILE}/UserLicenseTerminate`,
  blockUser: `${BASE_USER_PROFILE}/BlockUser`,
  webPubSubscribe: `${BASE_USER_PROFILE}/WebPubSubUrl`,
};

const UF = {
  ufConfig: `${BASE_UF}/UFConfig`,
  ufDetails: `${BASE_UF}/UFDetails`,
  designData: `${BASE_UF}/DesignData`,
  ufCalcReport: `${BASE_UF}/UFCalcReport`,
};

const IX_API_URLS = {
  resin: `${BASE_IX}/Resin`,
  ixData: `${BASE_IX}/IXData`,
  ixResin: `${BASE_IX}/IXResin`,
  ixDetails: `${BASE_IX}/IXDetails`,
  resinMapping: `${BASE_IX}/ResinMapping`,
  ixCalcReport: `${BASE_IX}/IXCalcReport`,
  advancedRegen: `${BASE_IX}/AdvancedRegen`,
  finalParameter: `${BASE_IX}/FinalParameter`,
  copyNewPlantDesign: `${BASE_IX}/CopyNewPlantDesign`,
  calculateRegenDose: `${BASE_IX}/CalculateRegenDose`,
  ixInitializationData: `${BASE_IX}/IXInitializationData`,
  resinSelectionChanged: `${BASE_IX}/ResinSelectionChanged`,
  ixCalculateChemAdjustment: `${BASE_IX}/ChemicalAdjustment`,
  vesselRegenerationSystem: `${BASE_IX}/VesselRegenerationSystem`,
  productQualityAndRegenerantDose: `${BASE_IX}/ProductQualityAndRegenerantDose`,
};

const RO_URLS = {
  roData: `${BASE_RO}/ROData`,
  ccroData: `${BASE_RO}/CCROData`,
  ccroFlowCalc: `${BASE_RO}/CCROFlowCalc`,
  roElements: `${BASE_RO}/SearchElement`,
  eeData: `${BASE_RO}/ExperimentalElement`,
  elementsData: `${BASE_RO}/Elements`,
  eeName: `${BASE_RO}/EEName`,
  roPassStage: `${BASE_RO}/PassStage`,
  ccroPassStage: `${BASE_RO}/CCROPassStage`,
  duplicateEE: `${BASE_RO}/DuplicateEE`,
  roReport: `${BASE_RO}/ROReport`,
  elementUsage: `${BASE_RO}/ElementUsage`,
  sendElement: `${BASE_RO}/SendEE`,
  showHideEE: `${BASE_RO}/ShowHideEE`,
  chemicalAdjust: `${BASE_RO}/ChemicalAdjust`,
  importElement: `${BASE_RO}/Import`,
};

const WM_URLS = {
  appVersion: `${BASE_WM}/appVersion`,
  deployBuilds: `${BASE_WM}/deployBuilds`,
  status: `${BASE_WM}/deployStatus`,
  cancel: `${BASE_WM}/cancel`,
};

const API_URLS = { ...MASTER_DATA, ...USER_PROFILE, ...UF, ...IX_API_URLS, ...RO_URLS, ...WM_URLS, ...MLD_URLS };

export default API_URLS;
